/**
 * Open Dropdown on "hover" for dynamically inserted elements
 * @requires https://getbootstrap.com
 * @requires https://popper.js.org/
 */

export default (() => {
  const initializeDropdownHover = (dropdownTriggerEl) => {
    const bsDropdown = new bootstrap.Dropdown(dropdownTriggerEl)

    dropdownTriggerEl.addEventListener('click', (e) => {
      if (e.currentTarget.getAttribute('href') === '#') {
        e.preventDefault()
      }
    })

    dropdownTriggerEl.addEventListener('mouseover', () => {
      dropdownTriggerEl.dataset.bsToggle = 'dropdown-hover'
      bsDropdown.show()
      dropdownTriggerEl.blur()
    })

    dropdownTriggerEl.parentNode.addEventListener('mouseleave', () => {
      dropdownTriggerEl.dataset.bsToggle = 'dropdown'
      bsDropdown.hide()
    })

    dropdownTriggerEl.addEventListener('focus', () => {
      bsDropdown.show()
    })

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        bsDropdown.hide()
      }
    })
  }

  const observeDropdowns = () => {
    const dropdownContainer = document.body

    // Initialize dropdowns for existing elements
    document
      .querySelectorAll('[data-bs-toggle="dropdown"][data-bs-trigger="hover"]')
      .forEach(initializeDropdownHover)

    // Observe for dynamically added elements
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.matches('[data-bs-toggle="dropdown"][data-bs-trigger="hover"]')
          ) {
            initializeDropdownHover(node)
          } else if (node.nodeType === 1) {
            node
              .querySelectorAll(
                '[data-bs-toggle="dropdown"][data-bs-trigger="hover"]'
              )
              .forEach(initializeDropdownHover)
          }
        })
      })
    })

    observer.observe(dropdownContainer, { childList: true, subtree: true })
  }

  if (!('ontouchstart' in window) || !navigator.maxTouchPoints) {
    observeDropdowns()
  }
})()
